/** JQUERY */
(function ($) {

  let lastScrollTop = 0;
  let currentScrollTop = 0;

  $(window).on("scroll", function () {
    currentScrollTop = $(this).scrollTop(); // Update current scroll position

    if (currentScrollTop > 200) {
      $("#site-header").addClass("scrolling");
    } else {
      $("#site-header").removeClass("scrolling");
    }

    // If scrolling up
    if (currentScrollTop > lastScrollTop && currentScrollTop > 100) {
      $("#site-header").addClass("scrolling-hide");
    } else {
      $("#site-header").removeClass("scrolling-hide");
    }

    lastScrollTop = currentScrollTop; // Update the last scroll position
  })
})(jQuery);

/**
 * Prevents white bar bug on load.
 * Applies `overflow-x: hidden` to #page on load and removes it after 1 second.
 * The removal ensures sticky properties remain functional.
 */
document.addEventListener('DOMContentLoaded', function () {
  let pageElement = document.querySelector('#page');
  if (pageElement) {
    pageElement.style.overflow = 'hidden';

    window.addEventListener('load', function () {
      setTimeout(function () {
        pageElement.style.overflow = '';
      }, 400);
    });
  }
});
